<div class="form-group" [class.has-success]="hasSuccess()" [class.has-error]="hasError()">
    <label for="inputSuccess">
        {{label}}
        <span class="text-danger" *ngIf="obrigatorio" matTooltip="Campo obrigatório">
          <strong>* </strong>
        </span>
        <i class="fas fa-info-circle" matTooltipPosition="above" matTooltip="{{info ? info : 'Adicionar Info'}}"></i>
    </label>
    <ng-content></ng-content>
    <span class="help-block" [style.display]="hasSuccess() || hasError() ? 'block' : 'none'" [style.color]="hasError() ?
    'red' : 'green' "><i class="fas"
            [class.fa-check]="hasSuccess()" [class.fa-times]="hasError()"></i>
        {{hasError() ?
        errorMessage : hasSuccess() ? 'Ok' : ''}}</span>
</div>
